export default "__VITE_ASSET__DnRBry52__"